module.exports = __webpack_public_path__ + "img/axoo-logo.87748beb.png";